import React, { useState, useEffect, useCallback } from 'react';
import DismissableWarning from '#/shared/components/DismissableWarning';
import { storeItem } from '#/shared/utils/storage';
import { COOKIES_HELP_LINK, CHECK_STORAGE_KEY } from '#/shared/constants';

function CookiesWarningContainer() {
  const [showCookiesWarning, setShowCookiesWarning] = useState(false);
  useEffect(() => {
    /* 
      Since we're just interested in having access to storage, attempting
      to write to storage is the best way to check if the user has their
      browser configured correctly for the best experience.
      Re-enabling cookies is the most common way to give the app
      access to local storage so we encourage the user to do that.
    */
    storeItem(CHECK_STORAGE_KEY, true, () => setShowCookiesWarning(true));
  }, []);

  const onWarningDismissed = useCallback(
    () => setShowCookiesWarning(false),
    []
  );

  return showCookiesWarning ? (
    <DismissableWarning
      helpLink={COOKIES_HELP_LINK}
      copySection="cookies"
      onWarningDismissed={onWarningDismissed}
    />
  ) : null;
}

export default CookiesWarningContainer;
